import { render, staticRenderFns } from "./DTSerialManager.vue?vue&type=template&id=577bc890&scoped=true"
import script from "./DTSerialManager.vue?vue&type=script&lang=js"
export * from "./DTSerialManager.vue?vue&type=script&lang=js"
import style0 from "./DTSerialManager.vue?vue&type=style&index=0&id=577bc890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577bc890",
  null
  
)

export default component.exports